import {
  Grid, Hidden, List, ListItem, ListItemText, makeStyles, Menu, MenuItem, Typography,
  ListSubheader,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import FiltersContext from '../../contexts/FiltersContext';
import colors from '../../modules/colors';

function Filters({ showAge }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentMenu, setCurrentMenu] = React.useState(null);
  const {
    settingType, setSettingType, childAge, setChildAge,
  } = useContext(FiltersContext);

  const classes = makeStyles((theme) => ({
    button: {
      backgroundColor: colors.blue,
      color: colors.white,
      borderRadius: 4,
      marginRight: theme.spacing(1),
      maxWidth: '40%',
      '&:hover': {
        backgroundColor: colors.lightBlue,
        boxShadow: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '45%',
      },
    },
  }))();

  const handleFilterClick = (menu) => (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(menu);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSettingType = (value) => () => {
    setSettingType(value);
    setCurrentMenu(null);
  };

  const handleChangeChildAge = (value) => () => {
    setChildAge(value);
    setCurrentMenu(null);
  };

  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12} md={10}>
          <List
            component="nav"
            aria-label="Filters"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              padding: 0,
            }}
            subheader={(
              <Hidden smDown>
                <ListSubheader component="div" id="nested-list-subheader">
                  Filter By:
                </ListSubheader>
              </Hidden>
            )}
          >
            {showAge && (
              <ListItem
                className={classes.button}
                button
                dense
                aria-haspopup="true"
                aria-controls="lock-menu"

                onClick={handleFilterClick('childAgeMenu')}
              >
                <ListItemText
                  primary="Child Age"
                  secondary={(
                    <Typography style={{ color: '#fff' }} variant="caption">
                      {childAge}
                    </Typography>
                  )}
                />
                <ExpandMoreIcon />
              </ListItem>
            )}
            <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"

              onClick={handleFilterClick('settingTypeMenu')}
            >
              <ListItemText
                primary="Setting Type"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {settingType}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>
          </List>
        </Grid>
      </Grid>

      <Menu id="settingTypeMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'settingTypeMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={settingType === 'All'} onClick={handleChangeSettingType('All')}>
          {settingType === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Center-based child care" selected={settingType === 'Center-based child care'} onClick={handleChangeSettingType('Center-based child care')}>
          {settingType === 'Center-based child care' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Center-based child care
        </MenuItem>
        <MenuItem key="Family child care (FCC)" selected={settingType === 'Family child care (FCC)'} onClick={handleChangeSettingType('Family child care (FCC)')}>
          {settingType === 'Family child care (FCC)' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Family child care (FCC)
        </MenuItem>
      </Menu>

      <Menu id="childAgeMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'childAgeMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={childAge === 'All'} onClick={handleChangeChildAge('All')}>
          {childAge === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Infants and Toddlers" selected={childAge === 'Infants and Toddlers'} onClick={handleChangeChildAge('Infants and Toddlers')}>
          {childAge === 'Infants and Toddlers' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Infants and Toddlers
        </MenuItem>
        <MenuItem key="Preschoolers" selected={childAge === 'Preschoolers'} onClick={handleChangeChildAge('Preschoolers')}>
          {childAge === 'Preschoolers' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Preschoolers
        </MenuItem>
      </Menu>
    </>
  );
}

Filters.propTypes = {
  showAge: PropTypes.bool,
};

Filters.defaultProps = {
  showAge: false,
};

export default Filters;
